import React from 'react';
import { twMerge } from 'tailwind-merge';
import type { Countdown } from '../hooks/useCountdown';
type CountdownUnitsProps = {
  countdown: Countdown;
  tone?: 'light' | 'dark';
};
const pad = (n: number) => String(n).padStart(2, '0');
export function CountdownUnits({
  countdown,
  tone = 'light'
}: CountdownUnitsProps) {
  const dark = tone === 'dark';
  const units = [...(countdown.days > 0 ? [{
    value: String(countdown.days),
    label: countdown.days === 1 ? 'día' : 'días'
  }] : []), {
    value: pad(countdown.hours),
    label: 'hs'
  }, {
    value: pad(countdown.minutes),
    label: 'min'
  }, {
    value: pad(countdown.seconds),
    label: 'seg'
  }];
  return <div className="flex items-start justify-center gap-1.5 sm:gap-2" role="timer" aria-live="off" data-id="element-112" data-mp="23p5kde4e1k4n">
      {units.map((u, i) => <React.Fragment key={u.label} data-id="element-113" data-mp="9cxjzl9asb1h" data-mpi={i}>
          {i > 0 && <span aria-hidden="true" className={twMerge('pt-2.5 font-heading text-2xl font-black', dark ? 'text-white/50' : 'text-pink/50')} data-id="element-114" data-mp="9fjrxm03osk8">
              :
            </span>}
          <div className={twMerge('flex min-w-[62px] flex-col items-center rounded-2xl px-2 py-2.5 sm:min-w-[76px]', dark ? 'bg-white/10 ring-1 ring-white/15' : 'border border-pink/20 bg-white shadow-soft')} data-id="element-115" data-mp="2ppy9fptgtsvz">
            <span className={twMerge('font-heading text-[1.75rem] font-black tabular-nums leading-none sm:text-4xl', dark ? 'text-white' : 'text-navy')} data-id="element-116" data-mp="34dt4hcuy49c8">
              {u.value}
            </span>
            <span className={twMerge('mt-1 text-xs font-semibold uppercase tracking-wide', dark ? 'text-teal-light' : 'text-navy-soft')} data-id="element-117" data-mp="3dcejwz54f88s">
              {u.label}
            </span>
          </div>
        </React.Fragment>)}
    </div>;
}